import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vShow as _vShow, vModelCheckbox as _vModelCheckbox, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1e817917"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onSubmit"]
const _hoisted_2 = { id: "baseinfo" }
const _hoisted_3 = { class: "text-right" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "form-text text-muted" }, "画像の推奨サイズ：横幅 170px × 高さ 95px", -1))
const _hoisted_5 = { class: "col-sm-10" }
const _hoisted_6 = ["value"]
const _hoisted_7 = { id: "options" }
const _hoisted_8 = { class: "opheader" }
const _hoisted_9 = { class: "d-flex align-items-center" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "me-auto" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "オプション設定")
], -1))
const _hoisted_11 = { class: "opbody" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "displayCommonBelongings" }, "共通の持ち物を表示しない", -1))
const _hoisted_13 = { class: "mt-2" }
const _hoisted_14 = { id: "anserstartbg" }
const _hoisted_15 = { class: "anserstart" }
const _hoisted_16 = {
  class: "navistart",
  id: "startQuestion"
}
const _hoisted_17 = { href: "javascript:void(0)" }

import { computed, reactive, ref, unref } from 'vue'
import { ConciergeCategory } from '@/plugins/nicotto'
import { message } from '@/plugins/message'
import { useValidateForm } from '@/components/ui/validator'
import WysiwygEditor from '@/components/ui/WysiwygEditor.vue'
import InputImage from '@/components/ui/InputImage.vue'
import InputLinks from '@/components/ui/InputLinks.vue'
import FormGroup from '@/components/ui/FormGroup.vue'
import InputText from '@/components/ui/InputText.vue'
import IconPlus from "@/components/ui/IconPlus.vue"
import IconMinus from "@/components/ui/IconMinus.vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'ConciergeCategory',
  props: {
    modelValue: null
  },
  emits: ["update:modelValue", "changeIcon", "submit"],
  setup(__props: any, { emit }: { emit: ({
  (event: 'update:modelValue', category: ConciergeCategory): void,
  (event: 'changeIcon', file: File|null): void
  (event: 'submit'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  modelValue: ConciergeCategory
}


const display = ref<boolean>(false)
// eslint-disable-next-line func-call-spacing


const maxLinkLength = Number(process.env.VUE_APP_CONCIERGE_MAX_CATEGORY_LINK_LENGTH) || 10
const keys = ['pageId', 'name', 'description', 'lead', 'iconUrl', 'links', 'publishMode', 'displayCommonBelongings', 'belongings', 'startButtonName']
const category = reactive<any>({})
keys.forEach(key => {
  category[key] = computed({
    get() {
      return props.modelValue[key as keyof ConciergeCategory]
    },
    set(val) {
      emit('update:modelValue', new ConciergeCategory({ ...props.modelValue, [key]: val}))
    }
  })
})

const onChangeIcon = (file: File|null) => emit('changeIcon', file)

const form = ref<HTMLFormElement|null>(null)
const submit = () => {
  if (! useValidateForm(unref(form) as unknown as HTMLFormElement).isValid()) {
    return
  }
  emit('submit')
}

// サイト公開設定のラベル/ボタン表示テキスト
const publishModeLabel = {
  private: {
    label : '非公開',
    buttonLabel : '非公開'
  },
  publish: {
    label : '公開',
    buttonLabel : '公開'
  }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _withModifiers(submit, ["prevent"]),
    ref_key: "form",
    ref: form,
    class: "formTable",
    novalidate: ""
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(FormGroup, {
        label: "画面ID",
        required: true,
        "label-for": "page_id"
      }, {
        default: _withCtx(() => [
          _createVNode(InputText, {
            modelValue: category.pageId,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((category.pageId) = $event)),
            label: "画面ID",
            id: "page_id",
            pattern: "^[-_0-9A-Za-z]+$",
            "invalid-pattern-message": _unref(message)('concierge.validation.invalidPageIdPattern'),
            required: ""
          }, null, 8, ["modelValue", "invalid-pattern-message"])
        ]),
        _: 1
      }),
      _createVNode(FormGroup, {
        label: "カテゴリ名",
        required: true,
        "label-for": "name"
      }, {
        default: _withCtx(() => [
          _createVNode(InputText, {
            modelValue: category.name,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((category.name) = $event)),
            label: "カテゴリ名",
            required: true,
            id: "name"
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(FormGroup, {
        label: "説明文",
        "label-for": "description"
      }, {
        default: _withCtx(() => [
          _createVNode(InputText, {
            label: "説明文",
            id: "description",
            modelValue: category.description,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((category.description) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(FormGroup, {
        label: "アイコン",
        required: true,
        "label-for": "icon"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(InputImage, {
              id: "icon",
              modelValue: category.iconUrl,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((category.iconUrl) = $event)),
              width: _unref(ConciergeCategory).iconWidth,
              onChange: onChangeIcon,
              required: !__props.modelValue.iconPath
            }, null, 8, ["modelValue", "width", "required"]),
            _hoisted_4
          ])
        ]),
        _: 1
      }),
      _createVNode(FormGroup, {
        label: "リード文",
        "label-for": "lead"
      }, {
        default: _withCtx(() => [
          _createVNode(WysiwygEditor, {
            id: "lead",
            modelValue: category.lead,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((category.lead) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(FormGroup, {
        label: "関連リンク",
        "label-for": "links"
      }, {
        default: _withCtx(() => [
          _createVNode(InputLinks, {
            id: "links",
            modelValue: category.links,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((category.links) = $event)),
            "max-length": _unref(maxLinkLength)
          }, null, 8, ["modelValue", "max-length"])
        ]),
        _: 1
      }),
      _createVNode(FormGroup, {
        label: "公開設定",
        "label-for": "displayCategory",
        "help-link": `https://www.faq.nicotto-admin.jp/faq/faq/1000026/1000052.html`
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_5, [
            _withDirectives(_createElementVNode("select", {
              name: "publish",
              id: "displayCategory",
              class: "form-select",
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((category.publishMode) = $event))
            }, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(publishModeLabel, (mode, item) => {
                return _createElementVNode("option", {
                  key: item,
                  value: item
                }, _toDisplayString(mode.label), 9, _hoisted_6)
              }), 64))
            ], 512), [
              [_vModelSelect, category.publishMode]
            ])
          ])
        ]),
        _: 1
      }, 8, ["help-link"])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-sm btn-secondary",
            onClick: _cache[7] || (_cache[7] = ($event: any) => (display.value = !display.value))
          }, [
            _withDirectives(_createVNode(IconPlus, null, null, 512), [
              [_vShow, !display.value]
            ]),
            _withDirectives(_createVNode(IconMinus, null, null, 512), [
              [_vShow, display.value]
            ])
          ])
        ])
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_11, [
        _createVNode(FormGroup, {
          label: "共通の持ち物",
          "label-for": "commonBelongings",
          "help-link": `https://www.faq.nicotto-admin.jp/faq/faq/1000047/1000048.html`
        }, {
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              id: "displayCommonBelongings",
              "true-value": "false",
              "false-value": "true",
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((category.displayCommonBelongings) = $event))
            }, null, 512), [
              [_vModelCheckbox, category.displayCommonBelongings]
            ]),
            _hoisted_12,
            _createElementVNode("div", _hoisted_13, [
              (category.displayCommonBelongings!=='false')
                ? (_openBlock(), _createBlock(WysiwygEditor, {
                    key: 0,
                    label: "共通の持ち物",
                    id: "belongings",
                    modelValue: category.belongings,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((category.belongings) = $event))
                  }, null, 8, ["modelValue"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }, 8, ["help-link"]),
        _createVNode(FormGroup, {
          label: "スタートボタン名",
          required: false,
          "help-link": `https://www.faq.nicotto-admin.jp/faq/faq/1000047/1000049.html`,
          "label-for": "startButtonName"
        }, {
          default: _withCtx(() => [
            _createVNode(InputText, {
              modelValue: category.startButtonName,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((category.startButtonName) = $event)),
              label: "スタートボタン名",
              required: false,
              id: "startButtonName"
            }, null, 8, ["modelValue"]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("ul", _hoisted_15, [
                _createElementVNode("li", _hoisted_16, [
                  _createElementVNode("a", _hoisted_17, _toDisplayString(category.startButtonName ? category.startButtonName : '診断を始める'), 1)
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["help-link"])
      ], 512), [
        [_vShow, display.value]
      ])
    ]),
    _renderSlot(_ctx.$slots, "default")
  ], 40, _hoisted_1))
}
}

})